export const DISPLAY_PERMISSIONS = [
  'view_medical_records',
  'participate_in_doctor_visit',
  'create_doctor_visit',
]

export const FULL_APP_PERMISSION = 'view_full_app'

export const PERMISSIONS_STATUS = {
  APPROVED: 'approved',
  DENIED: 'denied',
  REQUESTED: 'requested',
}
